import { Injectable } from '@angular/core';
import { TNil } from '@app/app.interface';
import { EAnalyticsStatus } from '@enums/campaign-analytics.enum';
import { ComponentStore } from '@ngrx/component-store';

interface IManualDeliverableStatusMapState {
  statusMap: Map<string, EAnalyticsStatus | TNil>;
  updateVersion: number;
}

const initialState: IManualDeliverableStatusMapState = {
  statusMap: new Map<string, EAnalyticsStatus | TNil>(),
  updateVersion: 0,
};

@Injectable({
  providedIn: 'root',
})
export class ManualDeliverableStatusMapStore extends ComponentStore<IManualDeliverableStatusMapState> {
  public readonly statusMap$ = this.selectSignal((s) => s.statusMap);
  public readonly updateVersion$ = this.selectSignal((s) => s.updateVersion);

  public readonly updateStatus = this.updater(
    (state: IManualDeliverableStatusMapState, payload: { key: string; status: EAnalyticsStatus | TNil }) => {
      const newMap = new Map(state.statusMap);
      newMap.set(payload.key, payload.status);

      return {
        ...state,
        statusMap: newMap,
        updateVersion: state.updateVersion + 1,
      };
    },
  );

  public readonly initializeMap = this.updater(
    (state: IManualDeliverableStatusMapState, payload: Map<string, EAnalyticsStatus | TNil>) => {
      return {
        ...state,
        statusMap: payload,
        updateVersion: state.updateVersion + 1,
      };
    },
  );

  public readonly getStatus = (key: string): EAnalyticsStatus | TNil => {
    return this.get().statusMap.get(key);
  };

  constructor() {
    super(initialState);
  }
}
